<template>
    <v-container id="permissions">
        <v-row class="mx-1 mb-5 mt-1 heading-title">
            Permissions
        </v-row>

        <div class="d-flex align-center select_all">
            <v-checkbox
                v-model="selectAll"
                color="primary"
                class="ml-4"
                @click="handelSelectAll"
            />
            All Permissions
        </div>
        <v-row>
            <v-col>
                <v-list-item-group
                    multiple
                >
                    <v-list-item
                        v-for="permission in Permissions"
                        :key="permission.permission"
                    >
                        <v-list-item-action>
                            <v-checkbox
                                v-model="permission.granted"
                                color="primary"
                                @click="handelSelect"
                            />
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title>{{ permission.permission }}</v-list-item-title>
                            <v-list-item-subtitle>{{ permission.description }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    name: 'Permissions',
    data: () => ({
        selectAll: false,
        Permissions: []
    }),
    computed: {
        getUserDetails() {
            return this.$store.getters.user;
        },
        getUserPermissions() {
            return this.$store.getters.userPermissions;
        },
        getUserPermissionsCatalog() {
            return this.$store.getters.userPermissionsCatalog;
        },
        getEditUser() {
            return this.$store.getters.editUser;
        },
        getCompany() {
            return this.$store.getters.company;
        },
    },
    created() {
        let Permissions = [...this.getUserPermissions];
        let count = 0;
        let hasUserPermission = this.getUserPermissionsCatalog.reduce((acc, curr) => {
            if(this.getEditUser.ingroup === 'Locator') {
                acc[curr.permission] = (curr.ingroup_applies.includes('*') || curr.ingroup_applies.includes(this.getEditUser.ingroup));
            } else {
                acc[curr.permission] = (curr.ingroup_applies.includes('*') || curr.ingroup_applies.includes(this.getEditUser.ingroup)) && !curr.ingroup_applies.includes('Locator');
            }
            return acc;
        }, {});
        Permissions.map(item => {
            if(hasUserPermission[item.permission]) {
                if(item.granted) {
                    count += 1;
                }
                this.Permissions.push({
                    description: item.description,
                    granted: item.granted === '1' ? true : false,
                    permission: item.permission
                });
            }
        });
        if(this.Permissions.length === count) {
            this.selectAll = true;
        }
        this.setFormData();
    },
    methods: {
        handelSelectAll() {
            if(this.selectAll) {
                this.Permissions = this.Permissions.map(item => {
                    item.granted = true;
                    return item;
                });
            } else {
                this.Permissions = this.Permissions.map(item => {
                    item.granted = false;
                    return item;
                });
            }
        },
        handelSelect() {
            let count = 0;
            this.Permissions.map(item => {
                if(item.granted) {
                    count += 1;
                }
            });
            if(this.Permissions.length === count) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },
        savePermission() {
            if(this.getEditUser) {
                this.$store.commit('SET_EDIT_USER', { 
                    ...this.getEditUser,
                    userPermissions: this.Permissions.map(item => { 
                        return { 
                            permission: item.permission, 
                            granted: item.granted === true ? '1' : '0'
                        }; 
                    })
                });
            }
        },
        async saveUser() {
            if(this.getEditUser) {
                this.$store.commit('SET_EDIT_USER', { 
                    ...this.getEditUser,
                    userPermissions: this.Permissions.map(item => { 
                        return { 
                            permission: item.permission, 
                            granted: item.granted === true ? '1' : '0'
                        }; 
                    })
                });
            }

            if(this.getEditUser.account) {
                this.getEditUser.account = this.getEditUser.account.toUpperCase();
            }
            let payload = {
                account: this.getEditUser.account,
                cid: this.getCompany.cid,
                ingroup: this.getEditUser.ingroup,
                name: this.getEditUser.name,
                password: this.getEditUser.password,
                passwordConfirm: this.getEditUser.passwordConfirm
            };

            try {
                this.$emit('start-loader');
                let result = await webtmsBackend.addUser(payload);
                if(result.err) {
                    this.$emit('stop-loader');
                    throw result.err;
                }
                if(result.result === 'OK') {
                    let userObject = await webtmsBackend.getUser(result.uid);
                    if(userObject) {
                        if(this.getEditUser.company === '') {
                            this.getEditUser.company = userObject.company;
                        }
                        this.getEditUser.account = userObject.account;
                        userObject = { ...userObject, ...this.getEditUser };
                        delete userObject.userCompanies;
                        delete userObject.RECEIVE_OVERDUE_NOTIFICATION;
                        delete userObject.RECEIVE_COMPANY_EOD_AUDIT;
                        delete userObject.RECEIVE_COMPANY_EOD_REPORT;
                        delete userObject.RECEIVE_SYSTEM_SOD;
                        delete userObject.RECEIVE_SYSTEM_EOD;
                        delete userObject.RECEIVE_SYSTEM_CHECK_ERRORS;
                        delete userObject.RECEIVE_OVERDUE_NOTIFICATION_INTERVAL;
                        delete userObject.ALTERNATE_LOCATOR;
                        delete userObject.ASSIGNED_TICKET_LIMIT;
                        delete userObject.ASSIGNMENT_ON_HOLD;
                        delete userObject.FORCE_ALTERNATE_LOCATOR;
                        delete userObject.EMAIL_ASSIGNED_TICKETS;
                        delete userObject.VACATION1;
                        delete userObject.VACATION2;
                        delete userObject.VACATION3;
                        delete userObject.VACATION4;
                        delete userObject.VACATION5;
                        delete userObject.user_level;
                        
                        let updateUserResponse = await webtmsBackend.updateUser({uid: result.uid, ...userObject});
                        if(updateUserResponse.status === 'OK') {
                            this.$emit('stop-loader');
                            this.$store.dispatch('setSnackbar', { text: `User account "${updateUserResponse.user.name}" created successfully.` });
                            this.$store.commit('SET_EDIT_USER', null);
                            this.$router.push('users');
                        }
                        if(updateUserResponse.err) {
                            this.$emit('stop-loader');
                            this.$store.dispatch('setSnackbar', { color:'error', text: updateUserResponse.err });
                            this.$store.commit('SET_EDIT_USER', null);
                            this.$router.push('users');
                        }
                    }
                }
            } catch(error) {
                this.$emit('stop-loader');
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
                this.$store.commit('SET_EDIT_USER', null);
                this.$router.push('users');
            }
        },
        setFormData() {
            if(this.$route.query.id) { 
                this.isEditUser = true;
            }
            if(this.getEditUser) {
                if(this.getEditUser.userPermissions) {
                    this.Permissions = this.Permissions.map(userPermission => {
                        let permission = this.getEditUser.userPermissions.find(item => item.permission === userPermission.permission);
                        if(permission) {
                            userPermission.granted = permission.granted === '1' ? true : false;
                        }
                        return userPermission;
                    });
                    this.handelSelect();
                }
            }
        },
        async editUser() {
            try {
                if(this.getEditUser) {
                    this.$store.commit('SET_EDIT_USER', { 
                        ...this.getEditUser,
                        userPermissions: this.Permissions.map(item => { return { permission: item.permission, granted: item.granted }; })
                    });
                }
                let result = await webtmsBackend.updateUser({uid: this.$route.query.id, ...this.getEditUser});
                if(result.status === 'OK') {
                    if(this.getEditUser.account === this.getUserDetails.account) {
                        const getUserResult = await webtmsBackend.getUserObject(this.getUserDetails.uid);
                        this.$store.commit('SET_USER', getUserResult);
                    }
                    this.$store.dispatch('setSnackbar', { text: `User account "${result.user.name}" updated successfully.` });
                    this.$store.commit('SET_EDIT_USER', null);
                    this.$router.push('users');
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            } catch(error) {
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
            }
        }
    }
};
</script>
<style>
    .heading-title {
        font-weight: 500;
        font-size: 16px;
        color: var(--ll-text-primary);
    }
    #permissions .v-list-item__title {
        font-size: 14px;
    }
    #permissions .v-list-item__subtitle {
        font-weight: 400;
        font-size: 12px;
    }
    #permissions .select_all {
        font-weight: 400;
        font-size: 14px;
    }
</style>
